import { JuloUpdateEntry } from "./types"

export const gammalTillaggsorderBorttagenEntry: JuloUpdateEntry = {
  slug: "2026-05-14-gammal-tillaggsorder-borttagen",
  date: "2026-05-14",
  title: "Det gamla sättet att skapa tilläggsorder är borttaget",
  description:
    'Nu använder alla det nya, snabbare sättet att skapa tilläggsorder. Knappen "+ Skapa tilläggsorder" som tidigare låg i arbetsordern i mottagningen är borttagen, och fliken som hette "Tilläggsorder (ny)" på jobbsidan heter nu bara "Tilläggsorder". Det är samma typ av samling som vi nyligen gjorde med serviceförslagen i mottagningen — så att åtgärder läggs in på samma sätt överallt i Julo.',
  images: [
    {
      src: "/julo-updates/2026-05-14-gammal-tillaggsorder-borttagen/tillaggsorder-flik.png",
      alt: 'Sektionsnavigationen på jobbsidan med fyra rader: Åtgärder, Preliminärt kvittounderlag, den markerade fliken Tilläggsorder (utan "(ny)"-suffixet) och Slutanteckning till cyklist.',
    },
  ],
}
